import React, { useEffect, useState } from 'react';

const applyTheme = (isDark: boolean) => {
  if (isDark) {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', 'light');
  }
};

interface ThemeToggleProps {
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const [isDark, setIsDark] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('cabo-theme');
    const prefersLight =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: light)').matches;
    const initial = saved ? saved === 'dark' : !prefersLight;
    setIsDark(initial);
    applyTheme(initial);
  }, []);

  const toggle = () => {
    const next = !isDark;
    setIsDark(next);
    applyTheme(next);
    localStorage.setItem('cabo-theme', next ? 'dark' : 'light');
  };

  return (
    <div
      role="switch"
      aria-checked={isDark}
      className={`ios-switch ${isDark ? 'on' : ''} ${className}`}
      onClick={toggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      }}
      tabIndex={0}
      aria-label="Dark Mode"
    >
      <input type="checkbox" checked={isDark} readOnly />
    </div>
  );
};

export default ThemeToggle;
